





























































































import Vue from 'vue';
import Component from 'vue-class-component';
import GoogleSERPPreview, {GooglePreviewData} from '@/modules/seo/components/GoogleSERPPreview.vue';
import {Metadata, MetadataTranslation, SEOCompletor} from '@/modules/seo/types';
import {State, Mutation, Action} from 'vuex-class';
import OpenGrapEditor from '@/modules/seo/components/OpenGraphEditor.vue';
import {Prop, Watch} from 'vue-property-decorator';
import TwitterCardEditor from '@/modules/seo/components/TwitterCardEditor.vue';
import SEOAnalysis from '@/modules/seo/components/SEOAnalysis.vue';

/**
 * Editor de SEO
 *
 * Permite modificar los metadatos de una entidad SEO
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'google-serp-preview': GoogleSERPPreview,
        'opengraph-editor': OpenGrapEditor,
        'twitter-card-editor': TwitterCardEditor,
        SEOAnalysis,
    },
})
export default class SEODetail extends Vue {

    /**
     * Permite cambiar el título mostrado en la barra del componente
     */
    @Prop({type: String, default: 'SEO'})
    public title: string;

    /**
     * Deshabilita todos los campos del componente, el usuario no podrá
     * modificar
     */
    @Prop({type: Boolean, default: false})
    public disabled: boolean;

    @Prop({type: Boolean, default: false})
    public disableAnalysis: boolean;

    @Prop({type: String, default: ''})
    public disableAnalysisText: string;

    /**
     * Metadatos SEO actualmente mostrados por el componente
     */
    @State(state => state.seo.currentMetadata)
    public metadata: Metadata;

    @State(state => state.seo.processingSEOAnalysis)
    public processingSEOAnalysis: boolean;

    /**
     * Actualiza un campo/propiedad de la traducción actual de los metadatos SEO
     */
    @Mutation('seo/metadata/current/translation/field/update')
    public updateCurrentTranslationField: (payload: { field: string, value: any }) => void;

    /**
     * Permite registrar el componente encargado de auto-completar con información
     * externa los metadatos
     */
    @Mutation('seo/completor/set')
    public setSEOCompletor: (completor: SEOCompletor) => void;

    @Action('seo/completeSEO')
    public complete: () => void;

    /**
     * Ejecta el analisis SEO
     */
    @Action('seo/loadSEOAnalysisReport')
    public analyzeSEO: () => void;

    @Action('seo/initMetadataFields')
    public initMetadataFields: () => void;

    @Prop({type: Object, default: null})
    public completor: SEOCompletor | null;

    @Prop({type: Boolean, default: false})
    public disableKeywords: boolean;

    @Watch('completor')
    public watchCompletor (val: SEOCompletor) {
        this.setSEOCompletor(val);
    }

    public async mounted () {
        if (this.completor) {
            await this.setSEOCompletor(this.completor);
            await this.initMetadataFields();
            await this.complete();
        }
    }

    /**
     * Retorna la traducción actualmente en edición o una traducción vacía en
     * caso de no existir ninguna
     *
     * @returns {MetadataTranslation}
     */
    get translation (): MetadataTranslation {
        return this.$store.getters['seo/metadata/current/translation'] || new MetadataTranslation();
    }

    public update (field: string, value: any) {
        this.updateCurrentTranslationField({field, value});
    }

    get serpPreviewData (): GooglePreviewData {
        return new GooglePreviewData(
            this.translation.title,
            `${location.origin}/${this.translation.slug}`,
            this.translation.description,
        );
    }
}
